module.exports = __webpack_public_path__ + "8a798321297a70392c5245f06af1e3f7.png";